<template>
    <Card :title="$t('labels.apiCredential')">
        <div class="card-body">
            <div class="row">
                <FormGroup :label="$t('labels.name')" class="col-lg-6">
                    <Input
                        :model-value="credential?.name"
                        @update:model-value="credential.name = $event"
                    />
                </FormGroup>
                <FormGroup :label="$t('labels.service')" class="col-lg-6">
                    <AppSelect
                        :model-value="service?.key"
                        :selected-value="service?.name"
                        :options="integrationServices"
                        option-key="key"
                        option-value="name"
                        disabled
                    />
                </FormGroup>
            </div>
            <component
                v-if="serviceComponent"
                :is="serviceComponent"
                :credential="credential"
                ref="serviceFields"
                @update:loading="isFieldsLoading = $event"
            />
        </div>
        <div class="card-footer d-flex justify-content-end flex-wrap" :style="{ gap: '.5rem' }">
            <AppButton color="light" @click="deleteApiCredentials()">
                <i class="icon-trash mr-2"></i>
                {{ $t('buttons.delete') }}
            </AppButton>
            <AppButton color="indigo" :disabled="isLoading || isFieldsLoading || isSaving" @click="editApiCredentials()">
                <i class="icon-floppy-disk mr-2"></i>
                {{ $t('buttons.save') }}
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FormGroup from '../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../components/new/form/Input.vue';
import AppSelect from '../../../../components/new/form/select/AppSelect.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';

import { apiCredentialServiceComponents } from './apiCredentialServiceComponents';
import { httpClient } from '../../../../services/HttpClient';
import MessageNotificator from '../../../../services/MessageNotificator';

export default {
    name: "EditApiCredentialsPage",
    components: {
        Card, FormGroup, Input, AppSelect, AppButton
    },
    data() {
        return {
            credential: null,
            isLoading: true,
            isFieldsLoading: false,
            isSaving: false,
            integrationServices: Object.keys(apiCredentialServiceComponents).map(key => ({
                key,
                name: this.$t(`integrationServices.${key}`)
            }))
        };
    },
    computed: {
        service() {
            let service = this.integrationServices.find(service => service.key === this.credential?.service) ?? null;

            return service;
        },
        serviceComponent() {
            let serviceComponent = apiCredentialServiceComponents[this.credential?.service] ?? null;

            return serviceComponent;
        }
    },
    methods: {
        fetchApiCredential() {
            this.isLoading = true;

            httpClient.get(`/projects/${this.$route.params.projectUuid}/core/api-credentials/${this.$route.params.apiCredentialUuid}`).then(response => {
                this.credential = response.data.data;
            }).finally(() => {
                this.isLoading = false;
            });
        },
        async editApiCredentials() {
            let request = {
                name: this.credential.name,
                ...this.$refs.serviceFields.buildRequest()
            };

            this.isSaving = true;

            await httpClient.patch(`/projects/${this.$route.params.projectUuid}/core/api-credentials/${this.$route.params.apiCredentialUuid}`, request).then(() => {
                this.$router.replace({
                    name: 'ApiCredentialsPage'
                })
            }).finally(() => {
                this.isSaving = false;
            })
        },
        deleteApiCredentials() {
            new MessageNotificator().confirm(this.$t('alerts.confirm_delete', {
                value: this.$t('labels.apiCredential')
            }), () => {
                httpClient.delete(`/projects/${this.$route.params.projectUuid}/core/api-credentials/${this.$route.params.apiCredentialUuid}`).then(() => {
                    this.$router.replace({
                        name: 'ApiCredentialsPage'
                    })
                })
            })
        }
    },
    mounted() {
        this.fetchApiCredential();
    }
}
</script>
